/* global axios */
import ApiClient from '../ApiClient';

// Aceleres: teto no cliente para a listagem de conversas. O Rack::Timeout do
// servidor derruba a request em 35s; sem timeout no axios a promise ficava
// pendurada e o spinner nunca resolvia. 40s da folga pro 500 do servidor chegar
// antes. NAO usar timeout global: endpoints de LLM (captain) rodam ate 120s.
const CONVERSATION_LIST_TIMEOUT_MS = 40000;

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get({
    inboxId,
    status,
    assigneeType,
    page,
    labels,
    teamId,
    conversationType,
    sortBy,
    updatedWithin,
    atendidoIa,
    aceleresBox,
    skipCounts,
    priority,
    assigneeId,
    unreadOnly,
  }) {
    return axios.get(this.url, {
      params: {
        inbox_id: inboxId,
        team_id: teamId,
        status,
        assignee_type: assigneeType,
        page,
        labels,
        conversation_type: conversationType,
        sort_by: sortBy,
        updated_within: updatedWithin,
        atendido_ia: atendidoIa,
        aceleres_box: aceleresBox,
        skip_counts: skipCounts,
        priority,
        assignee_id: assigneeId,
        unread_only: unreadOnly,
      },
      timeout: CONVERSATION_LIST_TIMEOUT_MS,
    });
  }

  show(id, { aceleresBox } = {}) {
    return axios.get(`${this.url}/${id}`, {
      params: { aceleres_box: aceleresBox },
    });
  }

  filter(payload) {
    const params = { page: payload.page };
    if (payload.sortBy) {
      params.sort_by = payload.sortBy;
    }
    if (payload.aceleresBox) {
      params.aceleres_box = payload.aceleresBox;
    }
    if (payload.skipCounts !== undefined) {
      params.skip_counts = payload.skipCounts;
    }

    return axios.post(`${this.url}/filter`, payload.queryData, {
      params,
      timeout: CONVERSATION_LIST_TIMEOUT_MS,
    });
  }

  search({ q }) {
    return axios.get(`${this.url}/search`, {
      params: {
        q,
        page: 1,
      },
    });
  }

  toggleStatus({ conversationId, status, snoozedUntil = null }) {
    return axios.post(`${this.url}/${conversationId}/toggle_status`, {
      status,
      snoozed_until: snoozedUntil,
    });
  }

  togglePriority({ conversationId, priority }) {
    return axios.post(`${this.url}/${conversationId}/toggle_priority`, {
      priority,
    });
  }

  assignAgent({ conversationId, agentId, personal = false, start = false }) {
    const payload = {
      assignee_id: agentId,
    };

    if (personal) {
      payload.personal = true;
    }

    if (start) {
      payload.start = true;
    }

    return axios.post(`${this.url}/${conversationId}/assignments`, payload);
  }

  assignTeam({ conversationId, teamId }) {
    const params = { team_id: teamId };
    return axios.post(`${this.url}/${conversationId}/assignments`, params);
  }

  markMessageRead({ id }) {
    return axios.post(`${this.url}/${id}/update_last_seen`);
  }

  markMessagesUnread({ id }) {
    return axios.post(`${this.url}/${id}/unread`);
  }

  toggleTyping({ conversationId, status, isPrivate }) {
    return axios.post(`${this.url}/${conversationId}/toggle_typing_status`, {
      typing_status: status,
      is_private: isPrivate,
    });
  }

  mute(conversationId) {
    return axios.post(`${this.url}/${conversationId}/mute`);
  }

  unmute(conversationId) {
    return axios.post(`${this.url}/${conversationId}/unmute`);
  }

  clear(conversationId) {
    return axios.post(`${this.url}/${conversationId}/clear`);
  }

  meta({
    inboxId,
    status,
    assigneeType,
    labels,
    teamId,
    conversationType,
    atendidoIa,
    priority,
    assigneeId,
    skip_cache: skipCache,
  }) {
    return axios.get(`${this.url}/meta`, {
      params: {
        inbox_id: inboxId,
        status,
        assignee_type: assigneeType,
        labels,
        team_id: teamId,
        conversation_type: conversationType,
        atendido_ia: atendidoIa,
        priority,
        assignee_id: assigneeId,
        skip_cache: skipCache,
      },
    });
  }

  sendEmailTranscript({ conversationId, email }) {
    return axios.post(`${this.url}/${conversationId}/transcript`, { email });
  }

  updateCustomAttributes({ conversationId, customAttributes }) {
    return axios.post(`${this.url}/${conversationId}/custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  fetchParticipants(conversationId) {
    return axios.get(`${this.url}/${conversationId}/participants`);
  }

  updateParticipants({ conversationId, userIds }) {
    return axios.patch(`${this.url}/${conversationId}/participants`, {
      user_ids: userIds,
    });
  }

  getAllAttachments(conversationId) {
    return axios.get(`${this.url}/${conversationId}/attachments`);
  }

  getInboxAssistant(conversationId) {
    return axios.get(`${this.url}/${conversationId}/inbox_assistant`);
  }

  delete(conversationId) {
    return axios.delete(`${this.url}/${conversationId}`);
  }
}

export default new ConversationApi();
